// extracted by mini-css-extract-plugin
export default {"box":"register_box__gJXAl","form":"register_form__BvgMB","label":"register_label__i4vCr","title":"register_title__0Mqjj","input":"register_input__mOjeE","btn":"register_btn__ebKL7"};